<template>
    <div v-if="show">
      <h3>Server Status Dashboard</h3>

      <div v-for="server in servers" v-bind:key="server" class="card mb-5 p-5">
        <h4>{{ server.name }}</h4>
        <Channel v-bind:server="server"></Channel>
      </div>
    </div>
</template>

<script>

  import store from "node-back-client/src/store";
  import Channel from "../components/Channel";

  export default {
    name: 'Server',
    components: {Channel},
    methods: {
      async refresh() {
        this.servers = await store.custom.apis[store.custom.countryCode].servers.getServers();
      },
    },
    data() {
      return  {
        show:false,
        servers:{}
      }
    },
    created() {
      store.custom.callbacks.servers = (() => {
        this.refresh();
      });
      store.custom.callbacks.init = (() => {
        this.show = true;
      });

      if(store.custom.isInit) {
        this.show = true;
      }
    },
  }
</script>
